import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import {ProductList} from "../ProductList";
import { useSettings } from "../Context/SettingsContext";
import ReactPixel from 'react-facebook-pixel';

function CategoryProduct()
{
  const { categoryId } = useParams();
  const [products, setProducts] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = React.useState(null);
  const settings = useSettings();
  const location = useLocation();

  useEffect(() => {
    if(categoryName)
    {        
      ReactPixel.track('ViewContent', {       
        content_type: 'product_group',        
        content_category: categoryName
        }
      );
    }
  },[categoryName])

  useEffect(() => {

    const fetchProductsByCategory = async () => {
      try {

        setLoading(true);
        setError(null);

        const response = await fetch(`${settings.ApiUrl}/Stock/GetByCategory/${categoryId}`);

        if (!response.ok){
            setError('Ha ocurrido un problema al obtener los productos. Intenta más tarde.');
        }
        else{
            const data = await response.json();
            setProducts(data.products);
            setCategoryName(data.categoryName);
        }
        
      } catch (err) {
        setError(err.message);   
        setProducts([]);
        setCategoryName("");
        
      } finally {
        setLoading(false);
      }
    };

    if(categoryId){
        fetchProductsByCategory();
    }
    
  }, [categoryId]); 

    if (error) {
        return (
        <div className="error-message">          
            <p>Por favor, inténtalo de nuevo más tarde.</p>
        </div>
        );
    }

    return (
        <div>
        <ProductList products={products}
          title={categoryName} 
          loading={loading} 
          location={location.key}/>
        </div>
    );
};

export {CategoryProduct};